import React, { useCallback, useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

type usePullToRefreshConfig = {
    refreshContainerRef: React.RefObject<HTMLDivElement>;
};
export const usePullToRefresh = (config: usePullToRefreshConfig) => {
    const LODING_ICON_HIDE_DELAY = 1000;
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.between('xs', 'md'));
    const [refreshContainerRef, setRefreshContainerRef] = useState<any>(undefined);
    const [showRefreshLoader, setRefreshLoader] = useState<boolean>(false);
    const MAX = 128;
    const k = 0.4;
    let startingYPoint = 0;
    let currentYPoint = 0;
    let moveAction = null;

    const handleTouchStart = useCallback(
        (event: TouchEvent): void => {
            const refElement = refreshContainerRef?.current;
            if (!refElement) return;

            startingYPoint = event.touches[0].clientY;

            const handleTouchMove = (event: TouchEvent): void => {
                currentYPoint = event.changedTouches[0].clientY;
                const dyPoints = Math.abs(currentYPoint - startingYPoint);

                if (dyPoints < 0) {
                    return;
                }
                const finalDyPoints = MAX * (1 - Math.exp((-k * dyPoints) / MAX));
                moveAction = startingYPoint > currentYPoint ? 'down' : 'up';
                if (dyPoints > 150 && moveAction === 'up') {
                    setRefreshLoader(true);
                }
                refElement.style.transform = `translateY(${finalDyPoints}px)`;
            };

            const onTransitionEnd = (event: TouchEvent): void => {
                if (!refElement) return;

                refElement.style.transition = '';
                refElement.removeEventListener('transitionend', onTransitionEnd);
            };

            const handleTouchEnd = (event: TouchEvent): void => {
                if (!refElement) return;
                setTimeout(() => {
                    setRefreshLoader(false);
                }, LODING_ICON_HIDE_DELAY);
                refElement.style.transform = 'translateY(0)';
                refElement.style.transition = 'transform 0.2s';

                refElement.addEventListener('transitionend', onTransitionEnd);
                refElement.removeEventListener('touchmove', handleTouchMove);
                refElement.removeEventListener('touchend', handleTouchEnd);
            };

            refElement.addEventListener('touchmove', handleTouchMove);
            refElement.addEventListener('touchend', handleTouchEnd);
        },
        [refreshContainerRef]
    );

    useEffect(() => {
        if (isMobileView) {
            setRefreshContainerRef(config?.refreshContainerRef);
        }
    }, [config, isMobileView]);

    useEffect(() => {
        const refElement = refreshContainerRef?.current;
        if (!refElement) return;

        refElement.addEventListener('touchstart', handleTouchStart);

        return () => {
            refElement.removeEventListener('touchstart', handleTouchStart);
        };
    }, [refreshContainerRef, handleTouchStart]);

    return showRefreshLoader;
};
